import { Controller, useFormContext } from "react-hook-form";
import { PaymentMethodFormValues } from "../../types";
import { View } from "react-native-ui-lib";
import { Label, TextField } from "@towersystems/roam-common-native";
import { useTranslation } from "../../../../../../utilities/i18n";

export interface NameInputFieldProps {}

export const NameInputField = (props: NameInputFieldProps) => {
  const { t } = useTranslation("settings");
  const { control } = useFormContext<PaymentMethodFormValues>();
  return (
    <View>
      <Label required label={t("form.payment_method_name.label")}></Label>
      <Controller
        name="name"
        control={control}
        render={({
          field: { onChange, value, onBlur },
          fieldState: { error },
        }) => (
          <TextField
            onBlur={onBlur}
            value={value ?? ""}
            onChangeText={onChange}
            validationMessage={error ? error.message : undefined}
            placeholder={t("form.payment_method_name.placeholder")}
          />
        )}
      />
    </View>
  );
};
